import { render, staticRenderFns } from "./faq.vue?vue&type=template&id=f936cf28&scoped=true"
import script from "./faq.vue?vue&type=script&lang=js"
export * from "./faq.vue?vue&type=script&lang=js"
import style0 from "./faq.vue?vue&type=style&index=0&id=f936cf28&scoped=true&lang=scss"
import style1 from "./faq.vue?vue&type=style&index=1&id=f936cf28&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f936cf28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f936cf28')) {
      api.createRecord('f936cf28', component.options)
    } else {
      api.reload('f936cf28', component.options)
    }
    module.hot.accept("./faq.vue?vue&type=template&id=f936cf28&scoped=true", function () {
      api.rerender('f936cf28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/serve/faq.vue"
export default component.exports